export default __webpack_public_path__ + "static/dosimete-pencil-d415236f1fc19945ff2ee97d2ac32075.jpg";